module.exports = __webpack_public_path__ + "img/laying-parquet-off.b83e8496.svg";